const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/

/**
 * Reads a stored date-condition value. The editor stores the ISO instant of the picked local
 * midnight; MCP and Righty store `YYYY-MM-DD`, which is a calendar day and so is read as local
 * midnight rather than UTC midnight (the previous day west of UTC).
 */
export function parseConditionDate(value: unknown): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }
  if ((typeof value !== 'string' && typeof value !== 'number') || value === '') {
    return null
  }
  const match = typeof value === 'string' ? DATE_ONLY.exec(value) : null
  if (match) {
    const [year, month, day] = [Number(match[1]), Number(match[2]) - 1, Number(match[3])]
    const date = new Date(year, month, day)
    // The Date constructor rolls 2026-13-01 into 2027-01-01; reject days that don't exist.
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day ? date : null
  }
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}
